// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutRightTop} from 'components/Layout';
import {BackgroundImage} from 'components/Image';

type Props = {
  onOpenModalIndex: () => void,
};

export default function ButtonIndex(props: Props): React.Element<any> {
  return (
    <LayoutRightTop>
      <Index onClick={props.onOpenModalIndex}>
        <BackgroundImage source="./driving-zone/btn-top-index.png" />
      </Index>
    </LayoutRightTop>
  );
}

const Index = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 40 + 60 : 80 + 160)}px;
  height: ${(props) => (props.theme.layout.mobile ? 40 + 20 : 80 + 40)}px;
  padding: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px ${(props) => (props.theme.layout.mobile ? 30 : 80)}px;

  div {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;
